import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { LocalizedText } from 'bernie-l10n';

import { VoiceOfTheCustomer } from '@shared-ui/customer-voice-of-the-customer';

import { UitkSpacing } from 'uitk-react-spacing';

import { MesoFooter } from '../../meso/meso-footer';
import { PropertySearchListings } from '../property-search-listings';

export const Results = ({ handleShowMore, setResultRef, legalDisclaimer, errorMessage, pageName }) => (
  <>
    <h2 className="is-visually-hidden">
      <LocalizedText message="hotels.search.results.heading" />
    </h2>
    <PropertySearchListings setResultRef={setResultRef} handleShowMore={handleShowMore} />
    {errorMessage}
    <MesoFooter pageName={pageName} />
    <ErrorBoundary label="voice-of-the-customer">
      <UitkSpacing margin={{ medium: { blockstart: 'six' } }}>
        <div data-stid="shared-ui-voice-of-the-customer">
          <VoiceOfTheCustomer />
        </div>
      </UitkSpacing>
    </ErrorBoundary>
    {legalDisclaimer?.content && (
      <UitkSpacing padding={{ block: 'six' }}>
        <p
          dangerouslySetInnerHTML={{
            __html: legalDisclaimer?.content
              .filter(content => content.markupType === 'HTML')
              .map(content => content.text)
              .join('<br/><br/>'),
          }}
        />
      </UitkSpacing>
    )}
  </>
);
